export enum PositionReasonEnum {
  "CLIENT",

  "EXPERT",

  "DEALER",

  "SL",

  "TP",

  "SO",

  "ROLLOVER",

  "EXTERNAL CLIENT",

  "VMARGIN",

  "GATEWAY",

  "SIGNAL",

  "SETTLEMENT",

  "TRANSFER",

  "SYNC",

  "EXTERNAL SERVICE",

  "MIGRATION",

  "MOBILE",

  "WEB",

  "SPLIT",

  "CORPORATE ACTION",

  "FIRST",

  "LAST",
}
